"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.proxyDownloadInvoice = proxyDownloadInvoice;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
/**
 * 代理下载发票文件
 * @param {*} downloadUrl
 * @returns
 */
function proxyDownloadInvoice(downloadUrl) {
  return (0, _requestPIM.default)({
    url: '/xyInvoice/proxyDownload',
    method: 'post',
    data: {
      downloadUrl: downloadUrl
    },
    responseType: 'blob' // 重要：指定响应类型为blob
  });
}